(function () {

    'use strict';

    angular.module('iplusjs.tooltip', [
        'iplusjs.tooltip.info',
        'iplusjs.tooltip.content'
    ])
    .component('iplusjsTooltip', {
        restrict: 'AE',
        transclude: true,
        bindings: {
            name: '@itName',
            close: '@itClose'
        },
        templateUrl: 'common/tooltip/tooltip.html',
        controller: TooltipController,
        controllerAs: 'tooltipVm'
    });

    TooltipController.$inject = [];
    function TooltipController() {
    }
})();
